// Function to generate SVG pie chart
const generatePieSVG = (data, centerValue = '', radius = 50, innerCircleRadius = 20, centerFontSize = 14) => {
    const strokeColor = "#465C66";
    const strokeWidth = 0.5;
    const padding = 10;
    const center = radius + padding;
    const svgSize = center * 2;

    // Calculate total value from data segments
    const totalValue = data.reduce((sum, d) => sum + d.value, 0);
    let currentAngle = 0;

    // Convert polar coordinates to Cartesian (x, y)
    function polarToCartesian(cx, cy, r, angleDeg) {
        const angleRad = (angleDeg - 90) * (Math.PI / 180);
        return {
            x: cx + r * Math.cos(angleRad),
            y: cy + r * Math.sin(angleRad),
        };
    }

    // Describe SVG arc path for a pie slice between startAngleDeg and endAngleDeg
    function describeArc(cx, cy, r, startAngleDeg, endAngleDeg) {
        const start = polarToCartesian(cx, cy, r, endAngleDeg);
        const end = polarToCartesian(cx, cy, r, startAngleDeg);
        const largeArcFlag = endAngleDeg - startAngleDeg > 180 ? 1 : 0;

        return [
            `M ${start.x} ${start.y}`,             // Move to start point
            `A ${r} ${r} 0 ${largeArcFlag} 0 ${end.x} ${end.y}`, // Arc to end point
            `L ${cx} ${cy}`,                       // Line back to center
            `Z`,                                  // Close path
        ].join(" ");
    }

    // Create path elements for each data segment
    let paths = [];

    if (data.length === 1) {
        // 100% circle fallback
        paths.push(`
    <circle
      cx="${center}"
      cy="${center}"
      r="${radius}"
      fill="${data[0].color}"
      stroke="${strokeColor}"
      stroke-width="${strokeWidth}"
    />
  `);
    } else {
        paths = data.map(segment => {
            const sliceAngle = (segment.value / totalValue) * 360;
            const startAngle = currentAngle;
            const endAngle = currentAngle + sliceAngle;
            currentAngle += sliceAngle;

            const pathD = describeArc(center, center, radius, startAngle, endAngle);
            return `<path d="${pathD}" fill="${segment.color}" stroke="${strokeColor}" stroke-width="${strokeWidth}"/>`;
        });
    }

    // Outer circle around the pie chart
    const outerCircle = `
    <circle
      cx="${center}"
      cy="${center}"
      r="${radius}"
      fill="none"
      stroke="${strokeColor}"
      stroke-width="${strokeWidth}"
    />
  `;

    // Center circle and optional text inside pie chart
    let centerElements = '';
    if (centerValue !== '' && centerValue !== null) {
        centerElements = `
      <circle
        cx="${center}"
        cy="${center}"
        r="${innerCircleRadius}"
        fill="#FFFFFF"
      />
      <text
        x="${center}"
        y="${center}"
        text-anchor="middle"
        dominant-baseline="middle"
        font-size="${centerFontSize}"
        fill="#000"
      >
        ${centerValue}
      </text>
    `;
    }

    // Compose final SVG markup
    return `
    <svg
      width="${svgSize}"
      height="${svgSize}"
      viewBox="0 0 ${svgSize} ${svgSize}"
      xmlns="http://www.w3.org/2000/svg"
    >
      ${outerCircle}
      ${paths.join("\n")}
      ${centerElements}
    </svg>
  `.trim();
}

// Main function to create pie chart inside the given element
const mapPieChart = (el) => {
    if (!el) return;

    // Try to find the selected year from closest ancestor
    const selectEl = el.closest('.elt-map-section-map').querySelector('.tr-select-year-value');
    const selectedYear = selectEl ? selectEl.textContent.trim() : null;

    // Define data keys based on year
    let keys = [];
    if (selectedYear === '2025') {
        keys = ['material_recovery', 'energy_recovery', 'no_recovery', 'unknown'];
    } else {
        // Default or 2019
        keys = ['material_recovery', 'energy_recovery', 'civil_engineering_and_backfilling', 'other'];
    }
    const data = [];

    // Extract values and colors from data attributes, ignore if value <= 0
    keys.forEach(key => {
        const valueAttr = el.getAttribute(`data-${key}`);
        const colorAttr = el.getAttribute(`data-${key}-color`);

        if (valueAttr && colorAttr && +valueAttr > 0) {
            data.push({
                value: +valueAttr,
                color: colorAttr,
            });
        }
    });

    // Optional center value displayed inside the pie chart
    const centerValue = el.getAttribute('data-total_generated') ? (+el.getAttribute('data-total_generated') / 1000).toFixed(2) : '';

    // Generate SVG markup for pie chart
    const svgMarkup = generatePieSVG(data, centerValue, 50, 20, 12);

    // Find or create container element inside el to hold the SVG
    let pieChartContainer = el.querySelector('.tr-pie-chart');

    // Insert the SVG markup into the container
    pieChartContainer.innerHTML = svgMarkup;
};

export default mapPieChart;
